import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Card,
  CardContent,
  Typography,
  Box,
} from "@mui/material";

function TrayBalanceListCardModal({ open, onClose, trayBalance = [] }) {
  const visibleTrays = trayBalance.filter(
    (tray) => Number(tray.count) > 0
  );

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ fontWeight: "bold" }}>
        Tray Balance
      </DialogTitle>

      <DialogContent dividers>
        {visibleTrays.length === 0 ? (
          <Typography color="text.secondary">
            No trays currently with balance.
          </Typography>
        ) : (
          <Box display="flex" flexDirection="column" gap={1.5}>
            {visibleTrays.map((tray) => (
              <Card
                key={tray.id}
                variant="outlined"
                sx={{
                  width: "100%",
                  borderLeft: "4px solid #1976d2",
                }}
              >
                <CardContent
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    py: 1.5,
                    "&:last-child": { pb: 1.5 },
                  }}
                >
                  {/* LEFT */}
                  <Box>
                    <Typography fontWeight="600">
                      {tray.label}
                    </Typography>
                    <Typography
                      variant="body2"
                      color="text.secondary"
                    >
                      Price: ₹ {tray.price}
                    </Typography>
                  </Box>

                  {/* RIGHT */}
                  <Box textAlign="right">
                    <Typography
                      variant="h4"
                      fontWeight="bold"
                      color="primary"
                    >
                      {tray.count}
                    </Typography>
                    <Typography
                      variant="caption"
                      color="text.secondary"
                    >
                      Trays
                    </Typography>
                  </Box>
                </CardContent>
              </Card>
            ))}
          </Box>
        )}
      </DialogContent>

      <DialogActions sx={{ px: 3, py: 2 }}>
        <Button onClick={onClose} variant="contained">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default TrayBalanceListCardModal;
